import { modifyPageLayoutComponents } from '../PageLayout';
import {
  Installation,
  InstallationContainer,
  InstallationPageHeaderContainer,
  InstallationPageFooterContainer
} from './Installation';
import InstallationCard from './InstallationCard';

export { Installation, InstallationContainer, InstallationCard };

export const InstallationLayoutComponents = modifyPageLayoutComponents({
  pageHeader: InstallationPageHeaderContainer,
  content: InstallationContainer,
  pageFooter: InstallationPageFooterContainer
});
